import React from 'react';
import { Link, NavLink } from 'react-router-dom';
import { ArrowUpRightIcon } from 'lucide-react';
import { useDb } from '../../hooks/useDb';
const TABS = [{
  to: '/beheer/logboek',
  label: 'Logboek'
}, {
  to: '/beheer/agents',
  label: 'Agents'
}, {
  to: '/beheer/geheugen',
  label: 'Geheugen'
}, {
  to: '/beheer/huis',
  label: 'Huis'
}, {
  to: '/beheer/systeem',
  label: 'Systeem'
}, {
  to: '/beheer/anna',
  label: 'Anna'
}];
interface BeheerLayoutProps {
  title: string;
  intro: string;
  /** Right side of the page heading: counts, primary actions */
  aside?: React.ReactNode;
  children: React.ReactNode;
}

/** Quiet control room shell shared by Logboek, Huis and Systeem. */
export function BeheerLayout({
  title,
  intro,
  aside,
  children
}: BeheerLayoutProps) {
  const meta = useDb(t => t.meta);
  const allOk = meta.connections.lokaal && meta.connections.internet;
  return <div className="min-h-screen w-full bg-night-950 font-sans text-ink" data-id="element-158" data-mp="3gkqx26vzui6p">
      <header className="sticky top-0 z-30 border-b border-white/[0.06] bg-night-950/90 backdrop-blur-xl" data-id="element-159" data-mp="1gtxhbcg7ewp1">
        <div className="mx-auto flex h-16 max-w-[1600px] items-center gap-6 px-6 lg:px-10" data-id="element-160" data-mp="1csc6dwn8cshh">
          <Link to="/" className="flex items-baseline gap-2 whitespace-nowrap rounded-md focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent/60" data-id="element-161" data-mp="17t92wgmweubm">
            <span className="font-display text-[22px] font-light text-ink" data-id="element-162" data-mp="12twh7z7rjtam">Anna</span>
            <span className="text-[13px] text-ink-muted" data-id="element-163" data-mp="xwmitu2ec7an">Beheer</span>
          </Link>
          <nav aria-label="Beheer" className="no-scrollbar flex min-w-0 items-center gap-1 overflow-x-auto" data-id="element-164" data-mp="t3a5ig363mx7">
            {TABS.map(t => <NavLink key={t.to} to={t.to} className={({
            isActive
          }) => `whitespace-nowrap rounded-full px-3.5 py-1.5 text-[14px] font-medium transition-colors duration-150 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent/60 ${isActive ? 'bg-white/[0.09] text-ink' : 'text-ink-muted hover:text-ink'}`} data-id="element-165" data-mp="p0djsgibzap1">
                {t.label}
              </NavLink>)}
          </nav>
          <div className="ml-auto hidden items-center gap-5 text-[13px] md:flex" data-id="element-166" data-mp="3nncg7kqzg1sz">
            <span className="flex items-center gap-2 whitespace-nowrap text-ink-soft" data-id="element-167" data-mp="3rnmnd0qigy9f">
              <span className={`h-2 w-2 rounded-full ${allOk ? 'bg-accent' : 'bg-amber'}`} aria-hidden data-id="element-168" data-mp="j8mhhxy9ewfs" />
              {allOk ? 'Alles verbonden' : meta.connections.internet ? 'Lokaal gestoord' : 'Internet weg, lokaal werkt'}
            </span>
            <span className="tabular-nums text-ink-muted" data-id="element-169" data-mp="af9hkc1s2uk7">{meta.time}</span>
            <Link to="/" className="inline-flex items-center gap-1 whitespace-nowrap text-ink-muted transition-colors duration-150 hover:text-ink" data-id="element-170" data-mp="eguq5l7a4mol">
              Wand <ArrowUpRightIcon className="h-3.5 w-3.5" aria-hidden data-id="element-171" data-mp="12548ue974ubi" />
            </Link>
            <Link to="/bureau" className="inline-flex items-center gap-1 whitespace-nowrap text-ink-muted transition-colors duration-150 hover:text-ink" data-id="element-172" data-mp="16z8f0van0ybj">
              Bureau <ArrowUpRightIcon className="h-3.5 w-3.5" aria-hidden data-id="element-173" data-mp="2mo7yr7tnh9vc" />
            </Link>
            <Link to="/telefoon" className="inline-flex items-center gap-1 whitespace-nowrap text-ink-muted transition-colors duration-150 hover:text-ink" data-id="element-174" data-mp="31ep1qvlxo7uc">
              Telefoon <ArrowUpRightIcon className="h-3.5 w-3.5" aria-hidden data-id="element-175" data-mp="2whf3cqgkglud" />
            </Link>
          </div>
        </div>
      </header>

      <main className="mx-auto max-w-[1600px] px-6 pb-24 pt-10 lg:px-10" data-id="element-176" data-mp="23qx3dyb530l6">
        <div className="flex flex-wrap items-end justify-between gap-6" data-id="element-177" data-mp="2ino3yawjuicd">
          <div className="max-w-2xl" data-id="element-178" data-mp="2ioz31xf1v1x5">
            <h1 className="font-display text-[40px] font-light leading-tight text-ink" data-id="element-179" data-mp="2douq2hdcopbo">{title}</h1>
            <p className="mt-2 text-[16px] leading-relaxed text-ink-soft" data-id="element-180" data-mp="3u2kwhurxzpoh">{intro}</p>
          </div>
          {aside}
        </div>
        {children}
      </main>
    </div>;
}